import { render } from "./RelationshipSideBox.vue?vue&type=template&id=01dd7a78&scoped=true&ts=true"
import script from "./RelationshipSideBox.vue?vue&type=script&lang=ts"
export * from "./RelationshipSideBox.vue?vue&type=script&lang=ts"

import "./RelationshipSideBox.vue?vue&type=style&index=0&id=01dd7a78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01dd7a78"]])

export default __exports__